module.exports = __webpack_public_path__ + "img/i_02.592c5b6e.png";